<template>
  <el-drawer
    title="重置密码"
    :visible.sync="drawer"
    :modal-append-to-body="false"
    append-to-body
    destroy-on-close
    :wrapperClosable="false"
    @close="close"
    custom-class="widthCommon"
  >
    <el-form ref="addForm" :model="addForm" :rules="loginRules" status-icon label-width="73px" label-position="left" size="small" class="mx-20 bg-#fff py-20 pr-30">
      <el-form-item label="手机号：" prop="mobilePhone">
        <el-input v-angle="addForm.mobilePhone" v-model="addForm.mobilePhone" type="text" placeholder="填写手机号" class="mobilePhone" />
        <span class="getSmsCode" @click="getSms">{{ startCount ? `${countDown}s` : codeText }}</span>
      </el-form-item>
      <el-form-item label="验证码：" prop="smsCode">
        <el-input v-angle="addForm.smsCode" v-model="addForm.smsCode" type="text" :disabled="!addForm.mobilePhone" placeholder="填写验证码" />
      </el-form-item>
      <el-form-item label="密码：" prop="password">
        <el-input v-angle="addForm.password" v-model="addForm.password" placeholder="密码必须包括数字、字母，长度8到16位" />
        <ETips :marginTop="8" padding="0" background="#ffffff" color="#666666" :left="8" text="密码长度为8-16位，需同时包含数字和字母" />
      </el-form-item>
    </el-form>
    <!--:imgs="vcodeIamges"-->
    <Vcode :show="showCode" @success="success" @close="showCode = false" style="z-index: 999999 !important" />
    <FixedTwoButton activeClass="widthCommon">
      <ELButton size="small" describe="重置" :myFunction="resetForm" />
      <ELButton size="small" describe="提交" isAsync :myFunction="submitForm" type="primary" />
    </FixedTwoButton>
  </el-drawer>
</template>

<script>
import Vcode from 'vue-puzzle-vcode'
import { vcodeIamges } from '@/utils/file'
import { forgetPassword, sendSmsCode } from '@/api/user'
import md5 from 'md5'

export default {
  inject: ['indexThis'],
  components: {
    Vcode,
  },
  data() {
    return {
      vcodeIamges,
      showCode: false,
      drawer: false,
      addForm: {
        mobilePhone: '',
        password: '',
        smsCode: '',
      },
      loginRules: {
        mobilePhone: [
          { required: true, trigger: 'blur', message: '手机号不能为空' },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '手机号格式不正确',
            trigger: 'blur',
          },
        ],
        smsCode: [{ required: true, trigger: 'blur', message: '验证码不能为空' }],
        password: [
          { required: true, trigger: 'blur', message: '密码不能为空' },
          {
            required: true,
            pattern: /^(?=.*[A-Za-z])(?=.*\d)[^]{8,16}$/,
            message: '密码必须包括数字、字母，长度8到16位',
            trigger: 'blur',
          },
        ],
      },
      countDown: 60, // 倒计时
      startCount: false,
      countdownInterval: null,
      codeText: '获取验证码',
    }
  },
  watch: {
    drawer(val) {
      if (val) this.addForm.mobilePhone = this.USER_INFO.mobilePhone
    },
  },
  methods: {
    async submitForm() {
      const valid = await this.$refs.addForm.validate().catch(() => {})
      if (!valid) return false
      const res = await forgetPassword({
        mobilePhone: this.addForm.mobilePhone,
        smsCode: this.addForm.smsCode,
        password: md5(this.addForm.password).toUpperCase(),
      })
      if (res.errCode !== 0) return this.$message.error(res.errMsg)
      this.$message.success('重置成功')
      this.drawer = false
    },
    resetForm() {
      this.$refs.addForm.resetFields()
    },
    getSms() {
      this.$refs.addForm.validateField('mobilePhone', e => {
        if (!e) this.showCode = true
      })
    },
    async success() {
      const res = await sendSmsCode({
        mobilePhone: this.addForm.mobilePhone,
      })
      if (!res) return this.$message.error(res.errMsg)
      this.$message.success('验证码发送成功')
      this.showCode = false
      this.countDown = 60
      this.startCount = true
      this.startCountdown()
    },

    // 验证码倒计时
    startCountdown() {
      this.countdownInterval && clearInterval(this.countdownInterval)
      this.countdownInterval = setInterval(() => {
        if (this.countDown > 0) {
          this.countDown--
        } else {
          this.startCount = false
          this.codeText = '重新获取验证码'
          clearInterval(this.countdownInterval)
        }
      }, 1000)
    },

    close() {
      this.codeText = '获取验证码'
      clearInterval(this.countdownInterval)
    },
  },
}
</script>

<style lang="scss" scoped>
.getSmsCode {
  position: absolute;
  right: 30px;
  color: #3276ec;
  cursor: pointer;
  font-size: 15px;
  top: 50%;
  transform: translateY(-50%);
}
::v-deep .mobilePhone .el-input__inner {
  padding: 0 115px 0 15px !important;
}
</style>
